import Transfer, { TransferDirection } from "antd/lib/transfer";
import { useState } from "react";
import { IModelInfo } from "../domain/ModelInfos/IModelInfo";

interface IProps {
    models: IModelInfo[];
    onChange: (selectedModels: IModelInfo[]) => any;
}
export function ModelSelector(props: IProps) {
    const { models, onChange } = props;
    const [targetKeys, setTargetKeys] = useState<string[]>([]);
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    const onTransferChange = (nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        setTargetKeys(nextTargetKeys);
        onChange(models.filter(x => nextTargetKeys.includes(x.id)));
    };

    const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    return (
        <Transfer
            dataSource={models}
            listStyle={{ width: "100%" }}
            rowKey={(item) => item.id}
            titles={['Available', 'Selected']}
            targetKeys={targetKeys}
            selectedKeys={selectedKeys}
            onChange={onTransferChange}
            onSelectChange={onSelectChange}
            render={(item) => <>{item.name} ({item.namespace})</>}
        />
    );;
}
